import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from "../../reducers";

import * as model from "../../models";

@Component({
	template: `<checkout-display-component></checkout-display-component>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutComponent implements OnInit {

	constructor(private store$: Store<AppState>,
		private route: ActivatedRoute,
		private router: Router
	) {}

	ngOnInit() {
		// wenn der user einen customer auswaehlt, wird die scroll position der customer liste auf die checkout seite uebernommen
		// dies ist nicht erwuenscht und verwirrt den user
		// fuer weitere info siehe commit msg
		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0, 0)
		})
	}

}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout.component.ts